// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__15I9R","profile__content":"Profile_profile__content__1Mj93"};